import * as React from 'react';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import formatDate from 'date-fns/format';

/* @jsxImportSource @emotion/react */
import { css } from '@emotion/react'; /* eslint-disable-line */
import useKeyPress from 'app/hooks/useKeyPress';
import { colors } from "app/common/arctechv2/theme";

const navItems = [{
	name: 'Deliveries',
	href: '/d/deliveries/all'
}, {
	name: 'User Management',
	href: '/u/users/all'
}, {
	name: 'Clients',
	href: '/c/clients/all'
}, {
	name: 'Upload CSV',
	href: '/d/delivery-upload'
}, {
	name: 'File Uploads',
	href: '/d/file-uploads/all'
}, {
	name: 'Depots',
	href: '/z/depots/all'
}, {
	name: 'Run Summary',
	href: `/run/r/country/1/${formatDate(new Date(), 'yyyy-MM-dd')}`
}, {
	name: 'Charges',
	href: '/b/charges/all',
	access: (auth) => auth.user.role === "admin"
}];


const componentCss = css`

	width: 400px;
	height: 400px;

	.SiteMenuSectionBody {
		padding: var(--siteMenuSpacing);
	}

	.ClientSearch {
		width: 100%;
		height: 40px;
		padding: 0 10% 0 10px;
		font-weight: 700;
		border: none;
		background: transparent;
		font-size: 24px;
		color: #1BC5BD;
		transition: font-size 0.5s cubic-bezier(0.7,0,0.3,1);	

		margin-bottom: 10px;
		outline: none;
	}

	.ClientLogo {
		> img {
			height: 24px;
		}
	}
	
	.Client {
		background-color: #f5f8fa;
		border-radius: .475rem;
		margin-bottom: .5rem;
		align-items: center;
		display: flex;
		padding: .5rem;
		transition: color .15s ease-in-out,background-color .15s ease-in-out,border-color .15s ease-in-out,box-shadow .15s ease-in-out;
		text-decoration: none;
		cursor: pointer;

		&:hover {
			color: #7e8299;
			border-color: #e4e6ef;
			background-color: #e4e6ef;
		}

		&.selected {
			color: #7e8299;
			border-color: #e4e6ef;
			background-color: #e4e6ef;
		}
	}

	.ClientLogo {
		display: inline-block;
		flex-shrink: 0;
		position: relative;
		border-radius: .475rem;
		margin-right: 1.25rem;
	}

	.ClientName {
		color: ${colors.darkNavy};
		transition: color .2s ease,background-color .2s ease;
		color: ${colors.darkNavy};
		font-weight: 600;
		font-size: 1.075rem;
	}

	.ClientDeliveries {
		color: ${colors.darkNavy};
	}

`;

export default React.forwardRef(({ selectedNav, isVisible, hideNav }, ref) => {

	const [searchValue, setSearchValue] = useState('');
	const sv = searchValue?.toLowerCase();
	const auth = useSelector(state => state.auth);
	const search = React.useRef(null);

	useEffect(() => {
		if (selectedNav === 2) {
			search.current.focus()
		}
	}, [selectedNav])

	const [cursor, setCursor] = useState(0);

	const isArrowUp = useKeyPress('ArrowUp');
	const isArrowDown = useKeyPress('ArrowDown');
	const isEnter = useKeyPress('Enter');

	const filteredItems = navItems?.filter(ni => (!ni.access || ni.access(auth)) && ni.name.toLowerCase().indexOf(sv) > -1).slice(0, 9);

	const navigate = useNavigate();

	useEffect(() => {
		if (!isVisible) {
			setSearchValue('');
		}
	}, [isVisible]);

	useEffect(() => {
		if (isVisible && filteredItems && isArrowDown) {
			setCursor(prevState =>
				prevState < filteredItems.length ? prevState + 1 : prevState
			);
		}
	}, [isVisible, isArrowDown]);

	useEffect(() => {
		if (isVisible && filteredItems && isArrowUp) {
			console.log("IAU")
			setCursor(prevState => (prevState > 0 ? prevState - 1 : prevState));
		}
	}, [isVisible, isArrowUp]);

	useEffect(() => {
		if (isVisible && filteredItems && isEnter && cursor > 0) {
			navigate(filteredItems[cursor - 1].href);
			hideNav();
		} else if (isVisible && filteredItems && isEnter) {
			navigate(filteredItems[0].href);
			hideNav();
		}

	}, [isVisible, cursor, isEnter]);

	return <div css={componentCss} ref={ref} className={"SiteMenu__section " + (selectedNav == 0 ? "" : selectedNav > 2 ? "SiteMenu__section--left" : "") + (selectedNav == 0 ? "" : selectedNav < 2 ? "SiteMenu__section--right" : "")} hidden={selectedNav !== 2}>
		<section className="SiteMenuSection">
			<div className="SiteMenuSectionBody">
				<input onChange={e => {
					setCursor(0);
					if (selectedNav === 2) {
						setSearchValue(e.target.value);
					}
				}} value={searchValue} ref={search} className="ClientSearch" placeholder="Search Navigation..."></input>

				<div className="ClientList">
					{filteredItems?.map((client, i) => {
						return <div key={i} className={"Client" + (cursor === i + 1 ? ' selected' : '')} onClick={() => {
							navigate(client.href);
							hideNav();
						}}>
							<div className="ClientLogo">
								<img src={client.logoURI}></img>
							</div>
							<div className="d-flex flex-column">
								<span className="ClientName">{client.name}</span>
								<span className="ClientDeliveries">{client.code}</span>
							</div>
						</div>
					})}
				</div>
			</div>
		</section>
	</div>

});
